export enum ExecuteAutoExchange {
  EXECUTE_RECURRING_EXCHANGE = 'EXECUTE_RECURRING_EXCHANGE',
  UPDATE_ACKNOWLEDGEMENT = 'UPDATE_ACKNOWLEDGEMENT',
  VALIDATE_RECURRING_IRA_REDEMPTION = 'VALIDATE_RECURRING_IRA_REDEMPTION',
  PREPARE_AUTOEXCHANGE_PAYLOAD = 'PREPARE_AUTOEXCHANGE_PAYLOAD',
  VALIDATE_RECURRING_IRA_REDEMPTION_FULFILLED = 'VALIDATE_RECURRING_IRA_REDEMPTION_FULFILLED',
}
